import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import BridgeModal from './BridgeModal';
import { useExchange } from 'context/exchange/ExchangeContext';
import { RequireOnomyWallet } from 'components/RequireOnomyWallet';

export const initialErrorsState = { amountError: '', onomyWalletError: '', transactionError: '' };

export default function BridgeSwapMain() {
  const { bridgeTxStatus, bridgeApproveTxStatus, bridgeReset } = useExchange();
  const navigate = useNavigate();
  const [errors] = useState(initialErrorsState);

  function onClose() {
    if (bridgeTxStatus.pending || bridgeApproveTxStatus.pending) return;
    navigate('/');
    bridgeReset();
  }

  useEffect(() => {
    return () => bridgeReset();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const Props = {
    onClose,

    values: {
      errors,
    },
  };

  return (
    <RequireOnomyWallet>
      <BridgeModal {...Props} />
    </RequireOnomyWallet>
  );
}
